import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logoKlinik from '../assets/logo-gigi.png';

export function ClinicHeader() {
  const { isAuthenticated, user, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Otomatis menutup menu mobile dropdown jika layar di-resize kembali ke ukuran desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    setIsMenuOpen(false);
    logout();
    window.location.href = '/';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // 🟢 FUNGSI REDIRECT YANG SUDAH DISINKRONKAN DENGAN APPROUTES Anda
  const handleDashboardRedirect = (e) => {
    e.preventDefault(); // Mencegah interaksi bawaan tag button/anchor
    setIsMenuOpen(false);

    // Mengambil role dari state user, dengan fallback ke localStorage jika state telat load
    const rawRole = user?.role || localStorage.getItem('user_role') || '';
    const cleanRole = rawRole.trim().toLowerCase(); 

    if (!cleanRole) {
      navigate('/login');
      return;
    }

    // Navigasi disesuaikan dengan path yang ada di AppRoutes Anda
    switch (cleanRole) {
      case 'admin':
        navigate('/admin');
        break;
      case 'dokter':
        navigate('/dokter');
        break;
      case 'pasien':
        navigate('/pasien');
        break;
      default:
        navigate('/login');
        break;
    }
  };

  // Fallback nama agar tampilan tidak kosong "Halo, " saat state context memuat ulang data
  const userNama = user?.nama || localStorage.getItem('user_nama') || 'Pengguna';

  return (
    <nav id="header" className="relative">
      <div className="max-w-7xl">
        
        {/* ==========================================================================
           1. BAGIAN KIRI: LOGO & NAMA KLINIK (Akses Desktop & Mobile)
           ========================================================================== */}
        <div className="navbar-logo" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <Link to="/" onClick={() => setIsMenuOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none' }}>
            <div className="header-logo">
              <img
                src={logoKlinik}
                alt="Logo Klinik Gigi Desfa Sandra"
                className="header-logo__img"
              />
            </div>
            <h1 id="header-clinic-name" style={{ margin: 0 }}>Klinik Gigi Desfa Sandra</h1>
          </Link>
        </div>

        {/* ==========================================================================
           2. BAGIAN TENGAH: NAVIGASI UTAMA (Hanya Muncul Di Desktop: >= md)
           ========================================================================== */}
        <nav className="hidden md:flex">
          <a href="#beranda">Beranda</a>
          <a href="#layanan">Layanan</a>
          <a href="#jadwal">Jadwal</a>
          <a href="#kontak">Kontak</a>
        </nav>

        {/* ==========================================================================
           3. BAGIAN KANAN: UTENSIL LOGIN/LOGOUT/DASHBOARD (Desktop: >= md)
           ========================================================================== */}
        <div className="navbar-auth hidden md:flex" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {isAuthenticated ? (
            <div className="user-menu" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <span className="user-greeting" style={{ fontSize: '0.9rem', fontWeight: 600, color: '#334155' }}>
               
              </span>
              
              {/* Tombol Dashboard Desktop */}
              <button 
                onClick={handleDashboardRedirect}
                className="btn-dashboard-desktop"
                style={{ 
                  fontSize: '0.9rem', 
                  color: '#fff', 
                  backgroundColor: '#0284c7', 
                  fontWeight: 700, 
                  textDecoration: 'none', 
                  padding: '0.5rem 0.75rem', 
                  border: 'none', 
                  borderRadius: '0.375rem',
                  cursor: 'pointer'
                }}
              >
                Dashboard
              </button>

              <button className="btn-logout" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                Logout
              </button>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <Link to="/login" className="btn-login-desktop">
                Login
              </Link>
              <Link to="/register" style={{ fontSize: '0.9rem', color: '#0369a1', fontWeight: 700, textDecoration: 'none' }}>
                Daftar
              </Link>
            </div>
          )}
        </div>

        {/* ==========================================================================
           4. HAMBURGER TOGGLE TRIGGER (Hanya Muncul Di Mobile & Tablet: < md)
           ========================================================================== */}
        <button 
          className={`mobile-menu-toggle md:hidden ${isMenuOpen ? 'is-active' : ''}`} 
          onClick={toggleMenu}
          aria-label="Toggle Menu Mobile"
        >
          <div className="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </div>

      {/* ==========================================================================
         5. CANVAS MENU DROPDOWN (Hanya Aktif Di Mobile Menggunakan `.is-open`)
         ========================================================================== */}
      <div id="mobile-menu" className={isMenuOpen ? 'is-open' : ''}>
        <nav>
          <a href="#beranda" onClick={() => setIsMenuOpen(false)}>Beranda</a>
          <a href="#layanan" onClick={() => setIsMenuOpen(false)}>Layanan</a>
          <a href="#jadwal" onClick={() => setIsMenuOpen(false)}>Jadwal</a>
          <a href="#kontak" onClick={() => setIsMenuOpen(false)}>Kontak</a>
          
          {/* Garis Pembatas Menu Utama dan Autentikasi Mobile */}
          <div className="mobile-auth-divider" style={{ margin: '0.5rem 0', borderTop: '1px dashed #e2e8f0' }}></div>
          
          {isAuthenticated ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', padding: '0.5rem 0' }}>
              <span className="user-greeting" style={{ fontSize: '0.85rem', color: '#64748b', fontWeight: 600, paddingLeft: '1rem' }}>
               
              </span>
              
              {/* Tombol Dashboard Mobile */}
              <button 
                onClick={handleDashboardRedirect}
                className="btn-dashboard-mobile"
                style={{ 
                  textAlign: 'center', 
                  color: '#fff', 
                  backgroundColor: '#0284c7', 
                  fontWeight: 600, 
                  padding: '0.6rem 1rem', 
                  textDecoration: 'none', 
                  borderRadius: '0.375rem', 
                  fontSize: '0.9rem', 
                  margin: '0 0.5rem',
                  border: 'none',
                  cursor: 'pointer'
                }}
              >
                Ke Dashboard
              </button>

              <button className="btn-logout" onClick={handleLogout} style={{ width: '100%', textAlign: 'center', cursor: 'pointer' }}>
                Logout
              </button>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
              <Link to="/login" className="btn-login-mobile" onClick={() => setIsMenuOpen(false)}>
                Login
              </Link>
              <Link to="/register" onClick={() => setIsMenuOpen(false)} style={{ textAlign: 'center', color: '#0369a1', fontWeight: 700, padding: '0.75rem 1rem', textDecoration: 'none', fontSize: '0.9rem' }}>
                Daftar
              </Link>
            </div>
          )}
        </nav>
      </div>
    </nav>
  );
}

export default ClinicHeader;